export const getPathAdmin = () => {
  let url = window.location.pathname;
  const urlToMessages = url.startsWith('/adminv2') ? 'adminv2' : 'admin/v2';
  return urlToMessages;
};
